module.exports = __webpack_public_path__ + "static/media/Search_Small_Icon.c5585344.svg";